import { useState } from 'react'
import { cn } from '@/lib/utils'
import { MoneyIcon, LinesIcon } from './icons'
import { Button } from '../ui/button'
import { Input } from '../ui/input'

const COIN_IMAGE = 'https://api.builder.io/api/v1/image/assets/TEMP/0807cf78686644d02fcc622657519857189d13e8?width=1198'

export function StakeBecyCard() {
	const [autoStake, setAutoStake] = useState(false)

	return (
		<div className='relative flex w-full min-w-0 flex-col gap-4 overflow-hidden rounded-[14px] border border-border bg-secondary p-4 shadow-[0_4px_12px_0_hsl(var(--background)/0.2)]'>
			<div
				className='pointer-events-none absolute -right-24 -top-32 h-[280px] w-[280px] rounded-full opacity-70 blur-[110px]'
				style={{
					background: 'linear-gradient(270deg, hsl(var(--accent-blue)) 0%, hsl(var(--accent-green)) 100%)',
				}}
			/>

			<div className='relative z-10 flex flex-col gap-1'>
				<h3 className='text-lg font-medium tracking-[-0.27px] text-foreground'>Stake $BECY</h3>
				<p className='max-w-[320px] text-sm tracking-[-0.21px] text-muted-foreground'>Enter the amount of $BECY you would like to stake</p>
			</div>

			<img
				src={COIN_IMAGE}
				alt=''
				className='pointer-events-none absolute right-0 top-0 z-0 hidden h-[280px] w-[280px] object-contain opacity-90 sm:block xl:h-[340px] xl:w-[340px]'
			/>

			<div className='relative z-10 flex flex-col gap-3 sm:max-w-[298px]'>
				<div className='flex flex-col items-center gap-2 rounded-xl border border-info bg-background px-3 py-3'>
					<span className='text-sm font-medium tracking-[-0.21px] text-muted-foreground'>Balance</span>
					<span className='text-2xl font-semibold tracking-[-0.24px] text-subtle-foreground'>
						$ 5750
						<span className='text-base text-subtle-foreground'>.15</span>
					</span>
				</div>

				<div className='rounded-xl border border-border p-0.5'>
					<div className='flex items-center gap-2 rounded-[10px] bg-background px-3.5 py-2'>
						<MoneyIcon className='h-6 w-6 shrink-0 text-subtle-foreground' />
						<span className='flex-1 text-base font-medium tracking-[-0.24px] text-subtle-foreground'>5000 $BECY</span>
						<Button variant='secondary'>MAX</Button>
					</div>
				</div>

				<Button variant='primary'>Stake $BECY</Button>
			</div>

			<div className='relative z-10 flex flex-col gap-3 rounded-xl bg-background p-3 sm:flex-row sm:items-center sm:justify-between'>
				<div className='flex flex-col gap-1 sm:max-w-[388px]'>
					<span className='text-sm font-medium tracking-[-0.21px] text-foreground'>Auto Stake Deposit</span>
					<p className='text-xs leading-[132%] tracking-[-0.18px] text-subtle-foreground'>
						Our Auto Staking Deposit feature seamlessly increases your Staking Rewards by automatically depositing your $BECY into staking daily
					</p>
				</div>

				<button
					type='button'
					onClick={() => setAutoStake((v) => !v)}
					className={cn(
						'flex shrink-0 items-center gap-4 rounded-xl border p-1 pl-4 shadow-[inset_-4px_-4px_4px_0_hsl(var(--foreground)/0.02),inset_4px_4px_8px_0_hsl(var(--background)/0.52)] transition-colors',
						autoStake ? 'flex-row-reverse border-primary bg-accent pl-1 pr-4' : 'border-primary bg-accent',
					)}
				>
					<span className='text-xs font-semibold tracking-[-0.18px] text-muted'>{autoStake ? 'ON' : 'OFF'}</span>
					<span className='flex h-[50px] w-[50px] shrink-0 items-center justify-center rounded-lg border border-foreground/10 bg-primary'>
						<LinesIcon className='h-6 w-6 text-background' />
					</span>
				</button>
			</div>
		</div>
	)
}
